<template>
	<div class="popup-info w-100 p-3">
		<b-row>
			<b-col sm="12" md="6" class="text-center">
				<img :src="`${publicPath}/img/rcp/${data[name].image[0]}.png`" class="mw-100">
			</b-col>
			<b-col sm="12" md="6" class="text-center">
				<img :src="`${publicPath}/img/rcp/${data[name].image[1]}.png`" class="mw-100">
			</b-col>
			<b-col xl="12" class="mt-3">
				<div class="small fw-700 mb-1">{{ $t(data[name].title) }}</div>
				<ol class="small p-0 pl-3">
					<li v-for="(item, index) in data[name].list" :key="index">{{ $t(item) }}</li>
				</ol>
			</b-col>
		</b-row>
	</div>
</template>

<script>
const data = {
	poi: {
		title: "Proof of Identity (POI) Reference",
		image: ["poi-sample-1", "poi-sample-2"],
		list: [
			"Keep fingers or hands out of the photo.",
			"Include the entire document in the frame.",
			"Check for clear legibility of all text",
			"Only JPEG, PNG file is allowed.",
			"Maximum file size is 8MB"
		]
	},
	poa: {
		title: "Proof of Address (POA) Reference",
		image: ["poa-sample-1", "poa-sample-2"],
		list: [
			"The document must be no more than three months old.",
			"Keep fingers or hands out of the photo.",
			"Include the entire document in the frame.",
			"Check for clear legibility of all text.",
			"Only JPEG, PNG file is allowed.",
			"Maximum file size is 8MB"
		]
	},
	selfie: {
		title: "Self Portrait Photo Reference",
		image: ["selfie-sample-1", "selfie-sample-2"],
		list: [
			"Maintain a neutral facial expression.",
			"Directly face the camera and hold the document",
			"Ensure hair doesn't cover the face.",
			"Avoid obstructions like masks or hands.",
			"Keep eyes open and visible.",
			"Do not apply filters or edit the photo."
		]
	}
};

export default {
	name: "popup-info",
	data() {
		return {
			publicPath: process.env.BASE_URL != '/' ? process.env.BASE_URL : '',
			data: data
		}
	},
	props: ["name"]
};
</script>

<style scoped>
.popup-info {
	overflow: auto;
	transform: translateX(-40%);
}

@media (max-width: 768px) {
	.popup-info {
		max-height: calc((30vw + 30vh) / 2); 
		transform: translateX(-20%);
	}
}

@media (max-width: 576px) {
	.popup-info {
		max-height: calc((40vw + 40vh) / 2); 
		transform: translateX(-60%);
	}
}

/* Custom scrollbar styles */
.popup-info::-webkit-scrollbar {
	width: 8px;
}

.popup-info::-webkit-scrollbar-thumb {
	background-color: #9088e0;
	border-radius: 4px;
}

.popup-info::-webkit-scrollbar-track {
	background-color: #f1f1f1;
}
</style>